var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.props.results.retrieved_chunks &&
    _setup.props.results.retrieved_chunks.length > 0
    ? _c("div", { staticClass: "source-files-section" }, [
        _c("div", { staticClass: "related-documents" }, [
          _vm._v(_vm._s(_setup.TEXT.relatedDocuments)),
        ]),
        _c(
          "div",
          { staticClass: "source-files-grid" },
          [
            _setup.gridConfiguration
              ? _c(_setup.Grid, {
                  attrs: {
                    saveConfiguration: "",
                    alias: _setup.LIST_NAME,
                    gridConfiguration: _setup.gridConfiguration,
                    itemData: _setup.props.results.retrieved_documents || [],
                    toolbarOptions: [],
                    commandClick: _setup.onCommandClick,
                  },
                  on: { rowClick: _setup.handleRowClick },
                })
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }